import { callApi } from "../api";

export const getAuthorizations = () => callApi("authorizations", null, "GET");

export const respondAuthorization = (body) => callApi("authorizations", body, "POST");

export const getTransactionalPinURL = () => callApi("transactional/pin", null, "GET");

export const validateTransactionalAuthCode = (body) => callApi("transactional/authcode", body, "POST");

export const getPaymentURL = (body) => callApi("payment/pin", body, "POST");

export const validatePaymentAuthCode = (body) => callApi("payment/authcode", body, "POST");
